import { createSelectorHook, createDispatchHook } from 'react-redux';
import { StoreContext } from './storeContext';
export const useTableSelector = createSelectorHook(StoreContext);
export const useTableDispatch = createDispatchHook(StoreContext);